/* global backUrl sponsorCommitmentDataUrl sponsorCommitmentStoreUrl sponsorCommitmentCancelUrl */
/* global suppliersIndexUrl suppliersStoreUrl suppliersCreateUrl getSponsorMilestonesUrl */
/* global minDate maxDate listUsersUrl currentUserId sponsor sponsorTier lineCrumbs */
/* global dependentsCount dependentNames */

import { React, useState } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import SponsorCommitForm from './SponsorCommitForm';

import { idempotencyHeader } from 'Helpers/apiUtils';

import { UsersProvider } from 'Context/UsersContext';

export default function SponsorCommit() {
    // One idempotency key per mounted screen, so a double-clicked commit (or a retried request) can
    // never create two commitments for the same intent.
    const [mutationHeader] = useState(idempotencyHeader());

    return (
        <SponsorCommitForm
            backUrl={backUrl}
            sponsorCommitmentDataUrl={sponsorCommitmentDataUrl}
            storeUrl={sponsorCommitmentStoreUrl}
            cancelUrl={sponsorCommitmentCancelUrl}
            mutationHeader={mutationHeader}
            suppliersIndexUrl={suppliersIndexUrl}
            suppliersStoreUrl={suppliersStoreUrl}
            suppliersCreateUrl={suppliersCreateUrl}
            getSponsorMilestonesUrl={getSponsorMilestonesUrl}
            minDate={minDate}
            maxDate={maxDate}
            listUsersUrl={listUsersUrl}
            currentUserId={currentUserId}
            sponsor={sponsor}
            sponsorTier={sponsorTier}
            dependentsCount={dependentsCount}
            dependentNames={dependentNames}
            lineCrumbs={lineCrumbs}
        />
    );
}

if (document.getElementById('SponsorCommit')) {
    var root = document.getElementById('SponsorCommit');
    ReactDOM.render(
        <App>
            <UsersProvider fetchUrl={listUsersUrl}>
                <SponsorCommit />
            </UsersProvider>
        </App>,
        root,
    );
}
